import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import {getModelForResourceType} from 'resources/modelRegistry';

import {Text, LoadingSpinner} from '@albert-io/atomic';

import SchoolSearchResultsList from './SchoolSearchResultsList.react';

const SchoolSearchResults = ({
  schoolNameSearchValue,
  isLoadingResults,
  results,
  selected,
  setSelected,
  onSubmit,
  shouldShowHelpText,
  errorMessage,
  multiSelect,
  hasExistingRecord,
  hideFooter,
  setMaxHeight
}) => {
  if (!schoolNameSearchValue) {
    // return list of only selected items if there's no search term
    return multiSelect ? (
      <SchoolSearchResultsList
        results={selected}
        selected={selected}
        setSelected={setSelected}
        onSubmit={() => onSubmit()}
        shouldShowHelpText={shouldShowHelpText}
        errorMessage={errorMessage}
        multiSelect={multiSelect}
        onlyShowChips
        hasExistingRecord={hasExistingRecord}
        hideFooter={hideFooter}
      />
    ) : null;
  }
  if (isLoadingResults) {
    return (
      <div className='school-lookup-modal__results-container mt-x2'>
        <div className='school-lookup-modal__results-container--border flex flex-col items-center justify-center px-x2 pt-x5 pb-x3'>
          <LoadingSpinner size={2} />
        </div>
      </div>
    );
  }
  if (results.size === 0) {
    return (
      <div className='school-lookup-modal__results-container mt-x2'>
        <div className='school-lookup-modal__results-container--border flex flex-col items-center justify-center px-x2 py-x5'>
          <Text bold className='mb-x1'>
            No results found.
          </Text>
          <Text> Try modifying your search.</Text>
        </div>
      </div>
    );
  }
  if (results.size > 24) {
    return (
      <div className='school-lookup-modal__results-container mt-x2'>
        <div className='school-lookup-modal__results-container--border flex flex-col items-center justify-center px-x2 py-x5'>
          <Text bold className='mb-x1'>
            Too many results.
          </Text>
          <Text> Try narrowing your search using the filters above.</Text>
        </div>
      </div>
    );
  }
  return (
    <SchoolSearchResultsList
      results={results}
      selected={selected}
      setSelected={setSelected}
      onSubmit={() => onSubmit()}
      shouldShowHelpText={shouldShowHelpText}
      errorMessage={errorMessage}
      multiSelect={multiSelect}
      hasExistingRecord={hasExistingRecord}
      hideFooter={hideFooter}
      setMaxHeight={setMaxHeight}
    />
  );
};

SchoolSearchResults.propTypes = {
  schoolNameSearchValue: PropTypes.string,
  isLoadingResults: PropTypes.bool,
  results: PropTypes.instanceOf(List),
  selected: PropTypes.oneOfType([
    PropTypes.instanceOf(getModelForResourceType('school_v5')),
    PropTypes.arrayOf(PropTypes.instanceOf(getModelForResourceType('school_v5')))
  ]),
  setSelected: PropTypes.func,
  onSubmit: PropTypes.func,
  shouldShowHelpText: PropTypes.bool,
  errorMessage: PropTypes.node,
  multiSelect: PropTypes.bool,
  hasExistingRecord: PropTypes.func,
  hideFooter: PropTypes.bool,
  setMaxHeight: PropTypes.bool
};

export default SchoolSearchResults;
